/**
 * Maximum number of suggested (popular feed) items to display in the playlist.
 */
export const DEFAULT_SUGGESTION_SIZE = 5;
